import { createStore } from 'effector-root'
import { DropdownItem } from '@/pages/common/types'
import { mapApplicationsCoursesType } from '@/pages/learning/learning-courses/constants'
import { createFilter } from '@/pages/common/filter-dropdown/create-filter'

export const applicationsCourseTypeDropdownModule = createFilter()

export const $courseApplicationsType = createStore<DropdownItem[]>(mapApplicationsCoursesType)
